import { FiSearch, FiSliders, FiCalendar } from "react-icons/fi";
import "../../styles/HomeSteps.css";

export default function HomeSteps() {
  return (
    <section className="home-steps">
      <div className="steps-container">
        
        <h2 className="steps-title">
          Simple Steps to <span>Justice</span>
        </h2>

        <p className="steps-subtitle">
          Our streamlined process makes finding legal help efficient and stress-free.
        </p>

        <div className="steps-grid">

          {/* Step 1 */}
          <div className="step-card">
            <div className="step-icon">
              <FiSearch />
            </div>
            <h3>1. Search</h3>
            <p>
              Filter by legal specialty, location, and price range to find the perfect match.
            </p>
          </div>

          {/* Step 2 */}
          <div className="step-card">
            <div className="step-icon">
              <FiSliders />
            </div>
            <h3>2. Compare</h3>
            <p>
              Read verified reviews, check success rates, and compare solicitor profiles.
            </p>
          </div>

          {/* Step 3 */}
          <div className="step-card">
            <div className="step-icon">
              <FiCalendar />
            </div>
            <h3>3. Book</h3>
            <p>
              Schedule a consultation instantly through our secure platform.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}